import { Conversion } from "./conversion";

export class Price {
	private wallet: Conversion = new Conversion();
	private default_amounts: Conversion[] = [new Conversion()];
	private price: Conversion = new Conversion();
	private maximum_bfc: Conversion = new Conversion();
	private minimum_internal: Conversion = new Conversion();
	private minimum_external: Conversion = new Conversion();
	private maximum_internal: Conversion = new Conversion();
	private maximum_external: Conversion = new Conversion();
	private minimum: Conversion = new Conversion();
	private instant_trade_bonus_rate: string = "";
	private app_test_trading_warning = false;

	private maxAmountWithoutFee: number = null;

	public getMaxAmountWithoutFee(): number {
		return this.maxAmountWithoutFee;
	}
	public setMaxAmountWithoutFee(n: number): void {
		this.maxAmountWithoutFee = n;
	}

	public getAmounts(): Conversion[] {
		return this.default_amounts;
	}

	public getPrice(): Conversion {
		return this.price;
	}

	public getMaxBfcAmounts(): Conversion {
		return this.maximum_bfc;
	}

	public get tradeMin(): Conversion {
		return this.minimum;
	}

	public getMinAmountInternal(): Conversion {
		return this.minimum_internal;
	}

	public getMinAmountExternal(): Conversion {
		return this.minimum_external;
	}

	public getMaxAmountInternal(): Conversion {
		return this.maximum_internal;
	}

	public getMaxAmountExternal(): Conversion {
		return this.maximum_external;
	}

	public getMaxAmount(): Conversion {
		return this.wallet;
	}

	public getWallet(): Conversion {
		return this.wallet;
	}

	public getItb(): string {
		return this.instant_trade_bonus_rate;
	}

	public getAppTestTradingWarning(): boolean {
		return this.app_test_trading_warning;
	}
}
